export default "__VITE_ASSET__Delyipro__"